import script from "./NewsHub.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsHub.vue?vue&type=script&setup=true&lang=js"

import "./NewsHub.vue?vue&type=style&index=0&id=72b77394&lang=scss"

const __exports__ = script;

export default __exports__